"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Counter = void 0;
var _logger = require("@ori/logger");
var _presentationComponents = require("@ori/presentation-components");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Counter = () => {
  const logger = (0, _logger.useLogger)('Counter');
  const {
    shouldRenderItemCount = true,
    totalItemCount = 0
  } = (0, _contexts.useProductList)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  if (!shouldRenderItemCount) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      logger: logger,
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ItemsCounterSkeleton, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ItemsCounter, {
        text: formatMessage('xProducts', {
          value: totalItemCount
        })
      })
    })
  });
};
exports.Counter = Counter;
//# sourceMappingURL=Counter.js.map